// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"069e870c","404":"28936cc1","787":"5fa7037b"}[chunkId] + ".chunk.js";
};